import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppraisalService } from '../services/appraisal.service';

@Component({
  selector: 'app-assessment-l2',
  templateUrl: './assessment-l2.component.html',
  styleUrls: ['./assessment-l2.component.css']
})
export class AssessmentL2Component implements OnInit {
  clickStatus = false;
  alreadySubmit = false;
  alreadyDraft = false;
   form_id;
   formData =
  {
    'form_id':''
  };
  userData = {
    form_id : '',
    employee_code: '',
    employee_name : '',
    appraisal_period : '',
    employee_qualification : '',
    employee_designation : '',
    employee_department : '',
    employee_division : '',
    employee_tasks : '',
    employee_achivements : '',
    employee_contributions_during_period : '',
    employee_contributions_file : '',
    employee_overcome_difficulties : '',
    help_from_supervising_officer : '',
    employee_scope_of_improvement : '',
    employee_suggestion : '',
    signature_date : '',
    entry_date : '',
    l2_employee_name : '',
    l2_employee_designation : '',
    l2_comments : '',
    l2_is_submit : '0'


  }

  constructor( private apprais : AppraisalService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.form_id = this.route.snapshot.params.form_id;
     //console.log(this.form_id);
     this.formData.form_id = this.form_id;
    var user = this.apprais.getFormInfo(this.formData).subscribe(res=>{
        //console.log(res);
        this.userData.form_id = res.form_info.id;
        this.userData.employee_code = res.form_info.employee_code_app;
        this.userData.employee_name = res.form_info.employee_name_app;
        this.userData.appraisal_period = res.form_info.appraisal_period;
        this.userData.employee_qualification = res.form_info.employee_qualification;
        this.userData.employee_designation = res.form_info.employee_designation;
        this.userData.employee_department = res.form_info.employee_department;
        this.userData.employee_division = res.form_info.employee_division;
        this.userData.employee_tasks = res.form_info.employee_tasks;
        this.userData.employee_achivements = res.form_info.employee_achivements;
        this.userData.employee_contributions_during_period = res.form_info.employee_contributions_during_period;
        this.userData.employee_overcome_difficulties = res.form_info.employee_overcome_difficulties;
        this.userData.help_from_supervising_officer = res.form_info.help_from_supervising_officer;
        this.userData.employee_scope_of_improvement = res.form_info.employee_scope_of_improvement;
        this.userData.employee_suggestion = res.form_info.employee_suggestion;
        this.userData.l2_employee_name = res.form_info.l2_employee_name;
        this.userData.l2_employee_designation = res.form_info.l2_employee_designation;
        this.userData.l2_comments = res.form_info.l2_comments;
        this.userData.l2_is_submit = res.form_info.l2_is_submit;
    })
  }
  isValid(l2comment,control) 
  {
   
    if((!l2comment.controls[control].valid && (l2comment.controls[control].dirty ||l2comment.controls[control].touched)) || (!l2comment.controls[control].valid && this.clickStatus))
    {
      // var errorStr = '<div class="alert alert-danger"> * ' + control+ ' is required</div>';
      var errorStr = '<div class="alert alert-danger"> * ' + 'This field is required</div>';
      return errorStr;
    }
  }

  onDraft(l2comment)
  {
    this.alreadyDraft = true;
    var selfData = this.apprais.setL2CommentData(l2comment.value).subscribe( res => {
      localStorage.setItem('appraisal_msg',res.message);
      this.router.navigate(['/selfAppraisalAssign']);
     })

  }

  onSubmit(l2comment)
  {
    this.clickStatus = true;
    if(l2comment.valid)
    {
     this.alreadySubmit = true;
     
    // console.log(l2comment.value);
     var formData = l2comment.value;
     formData.l2_is_submit = '1';

     //var form_id =  this.userData.form_id;
    var selfData = this.apprais.setL2CommentData(formData).subscribe( res => {
      //localStorage.setItem('appraisal_msg',res.message);
      this.router.navigate(['/number-assessmentL2/' + this.userData.form_id]);
     })
  }
}

conFun(l2comment)
{
  var r = confirm("Are you sure to submit the review?");
  if (r == true) {
    this.onSubmit(l2comment);
  }
}
}



// WEBPACK FOOTER //
// ./src/app/assessment-l2/assessment-l2.component.ts